import { atomWithStorage } from 'jotai/utils';

import { GalleryPeriods } from '@/enums';

export const galleryPeriodAtom = atomWithStorage<GalleryPeriods>('gallleryPeriod', GalleryPeriods.MONTH);
